import { BaseSettings } from 'Shared/frontend/themes/BaseSettings';
import { Questrial } from 'Shared/frontend/fonts/Questrial';
import { INav } from 'Common/config/INav';
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';
import {PeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 


export class TheTownieSettings extends BaseSettings
{

	fontIncludes()
	{
		return [ Questrial ];
	}

	fonts()
	{
		return {
			text: 'Questrial, sans-serif',
			heading: 'sans-serif',
			buttons: 'Questrial, sans-serif',
			desktopNav: 'sans-serif',
			mobileNav: 'Questrial, sans-serif',
			subNav: 'Questrial, sans-serif',
		};
	}

	pages()
	{
		return [
//TODO maybe put home & hire in BaseSettings?
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
			{
				key: 'club',
				frontend: {
					route: '/members',
					metaTitle: 'Club'
				},
				backend: {
					route: '/members',
					title: 'Club Townie'
				}
			},
			{
				key: 'reservation',
				frontend: {
					route: '/reservation',
					metaTitle: 'Reservation'
				},
				backend: {
					route: '/reservation',
					title: 'Reservation'
				}
			},
			{
				key: 'hireEnquiry',
				frontend: {
					route: '/hire-enquiry',
					metaTitle: 'Hire Enquiry'
				},
				backend: {
					route: '/hire-enquiry',
					title: 'Hire enquiry'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menus',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Club',		page:'club'},
				{label:'Contact',	link:'frontend/Contact'},
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Menus',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
					{label:'Club',		page:'club',				icon:Contact},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:PeopleCircle},
		];
	}
};

